import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  FamilyListingSearchService,
  categoryListingService,
  FamilyListingService,
} from "../../../services/MasterDataManagementService";
import FamilyList from "./FamilyList";
import useGlobalState from "../../../Context";

const ProductFamily = () => {
  const [totalElements, setTotalElements] = useState(0);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [categoryList, setCategoryList] = useState([]);
  const [productFamilyList, setProductFamilyList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchProductFamilyList("productFamilyName", false);
  }, []);

  const fetchProductFamilyList = async (sortBy, isAsc, id,searchValue,paginationData) => {
   
    try {
      setLoading(true);
      const obj = {
        pageNumber: paginationData?.pageNumber ?? 0,
        pageSize:  paginationData?.pageSize ??  10,
        filterSearch: searchValue? searchValue : null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        categoryId: null,
        sortDirection: isAsc ? "DESC" : "ASC",
        sortBy: sortBy,
      };
      const familyListingResponse = await FamilyListingService(obj);
      if (familyListingResponse.statusCode === 6) {
        if (familyListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setProductFamilyList(familyListingResponse.data.content);
        setTotalElements(familyListingResponse.data.totalElements);
      } else {
        showNotification("Error", familyListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
      showNotification("Error", "Faild to fetch product family list", "error");
    } finally {
      setLoading(false);
    }
  };

  const onSearch = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: "ASC",
        sortBy: "productFamilyName",
        active: loginUserType === "Main Admin" ? 2 : 0,
      };
      const familyListingResponse = await FamilyListingSearchService(
        requestBody,
        searchValue
      );
      if (familyListingResponse.statusCode === 6) {
        if (familyListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setProductFamilyList(familyListingResponse.data.content);
        setTotalElements(familyListingResponse.data.totalElements);
      } else {
        showNotification("Error", familyListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        active: loginUserType === "Main Admin" ? 2 : 0,
        filterSearch: searchValue ? searchValue.trim() : null,
        categoryId:  null,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        sortBy: orderBy,
      };
      const response = await FamilyListingService(requestBody);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setProductFamilyList([
            ...productFamilyList,
            ...response.data.content,
          ]);
        } else {
          setProductFamilyList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoryList = async () => {
    try {
      const requestBody = {
        pageSize: 1000,
        pageNumber: 0,
        filterSearch: null,
        active: 0,
        sortDirection: "DESC",
        sortBy: "categoryName",
      };
      const categoryListingResponse = await categoryListingService(requestBody);

      if (categoryListingResponse.statusCode === 6) {
        setCategoryList(categoryListingResponse.data);
      } else {
        showNotification("Error", categoryListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <FamilyList
      totalElements={totalElements}
      setProductFamilyList={setProductFamilyList}
      onSearch={onSearch}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      fetchCategoryList={fetchCategoryList}
      categoryList={categoryList}
      fetchProductFamilyList={fetchProductFamilyList}
      productFamilyList={productFamilyList}
      noRecord={noRecord}
    />
  );
};

export default ProductFamily;
